import { NgClass } from '@angular/common';
import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { UserNotes, UserNotesWrapper } from '@zero/shared/util-models';
import { UserNotesService } from '@zero/shared/util-web-app-services';
import { Subject, filter } from 'rxjs';

@Component({
  selector: 'web-components-user-notes',
  templateUrl: './user-notes.component.html',
  imports: [NgClass, NgbAlertModule],
})
export class UserNotesComponent implements OnInit {
  @Input() public target: string;
  @Input() public dismissibleNotes: boolean;
  @Input() public notifyLoadedNotesCount$: Subject<number>;
  @Input() public wrapperDivClasses: string | string[] | Set<string> | Record<string, any>;

  public wrapper: UserNotesWrapper;

  readonly #userNotesService = inject(UserNotesService);
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.#userNotesService
      .loadUserNotes(this.target)
      .pipe(
        filter((result) => !!result),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe((result: UserNotesWrapper) => {
        this.wrapper = result;

        if (result.custom?.length > 1) {
          // choose one randomly
          const crypto = window.crypto || window['msCrypto'];
          const index = Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] * result.custom.length);
          this.wrapper.custom = [result.custom[index]];
        }

        if (this.notifyLoadedNotesCount$) {
          const notesCount =
            (result?.success ? result.success.length : 0) +
            (result?.info ? result.info.length : 0) +
            (result?.danger ? result.danger.length : 0) +
            (result?.custom ? result.custom.length : 0);
          this.notifyLoadedNotesCount$.next(notesCount);
        }
      });
  }

  public closeNote(note: UserNotes, category: string): void {
    const index = this.wrapper[category].indexOf(note);
    if (index > -1) {
      this.wrapper[category].splice(index, 1);
    }
    if (note.dismissPermanently) {
      this.#userNotesService.dismissNotes([note]);
    }
  }

  public toggleNote = (event: Event, item: UserNotes): void => {
    item.dismissPermanently = (event.target as HTMLInputElement).checked;
  };
}
